// extracted by css-extract-rspack-plugin
export default {"cls1":"Results-cls1_5ew","cls2":"Results-cls2_7-k Results-cls1_5ew"};